/**
 * Mapeo de user_id de vendedor → teléfono real de WhatsApp.
 * Los contactos mock "estrella" del simulador usan el teléfono del vendedor
 * logueado, de forma que los mensajes de demo llegan a su dispositivo real.
 */

const VENDOR_PHONE_MAP = {
  israel: "+34660363064",
  manuel: "+34618391163",
  trini:  "+34660291185",
  david:  "+34657524749",
  pablo:  "+34656987797",
};

const FALLBACK_DEMO_PHONE = "+34660363064"; // israel por defecto

/** Teléfono fijo de David Romero (no vinculado a ningún vendedor). */
export const DAVID_ROMERO_PHONE = "+34657524749";

/**
 * Devuelve el teléfono del vendedor logueado, leyendo el user_id del JWT en
 * localStorage. Si no hay sesión o el user_id no está en el mapa, devuelve
 * el fallback (Israel).
 */
export function getVendorDemoPhone() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return FALLBACK_DEMO_PHONE;
    const [, payloadB64] = token.split(".");
    const payload = JSON.parse(
      atob(payloadB64.replace(/-/g, "+").replace(/_/g, "/"))
    );
    return VENDOR_PHONE_MAP[payload?.user_id] ?? FALLBACK_DEMO_PHONE;
  } catch {
    return FALLBACK_DEMO_PHONE;
  }
}
